import { Component, Input } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ContratoDetailDto } from '@models/contrato/contratoDetailDto.model';
import { DialogCardContratoComponent } from '@views/contratos/dialog-card-contrato/dialog-card-contrato.component';
import { isFalsy } from 'utility-types';

/**
 * Botón que abre el detalle de un contrato en un diálogo.
 *
 * Existía suelto en create-movimiento, con su propio spinner y su propia
 * configuración del diálogo. Como el detalle del contrato es útil en cualquier
 * pantalla donde se elija un contrato, conviene que sea un componente: quien lo
 * use sólo le pasa el contrato.
 *
 * Uso:  <app-btn-ver-contrato [contrato]="contratoDetailDto"></app-btn-ver-contrato>
 */
@Component({
  selector: 'app-btn-ver-contrato',
  templateUrl: './btn-ver-contrato.component.html',
  styleUrls: ['./btn-ver-contrato.component.css']
})
export class BtnVerContratoComponent {

  /** Sin contrato el botón queda deshabilitado, no oculto: así no salta el layout. */
  @Input() contrato!: ContratoDetailDto | null;

  /** Para mostrar el spinner mientras la pantalla que lo contiene busca el contrato. */
  @Input() cargando: boolean = false;

  /** Botón chico de sólo icono, para barras y celdas de tabla. */
  @Input() soloIcono: boolean = false;

  @Input() texto: string = "Ver";

  constructor(private dialog: MatDialog) { }

  get habilitado(): boolean {
    return !this.cargando && !isFalsy(this.contrato);
  }

  abrir() {
    if (!this.habilitado)
      return;

    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.width = '100%';
    dialogConfig.maxWidth = '95%';
    dialogConfig.data = this.contrato;

    this.dialog.open(DialogCardContratoComponent, dialogConfig);
  }
}
